import { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from "react-router-dom";
import { Search } from "../actions/Publication";
import SearchComponent from '../components/Search/search';

class SearchPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: {},
      loading: false,
      slug: ''
    };
  }
  componentDidMount = () => {
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    const { location } = this.props.history;
    var { pathname } = location;



    const { slug } = this.props.match.params;
   
    const requestData = {
      q: slug,
      page: 1,
    }
    this.props.Search(requestData).then((data) => {
      this.setState({
        content: data,
        slug: slug
      })
    });

  }

  componentDidUpdate = (prevProps) => {
    const { slug } = this.props.match.params;
    const { slug: prevSlug } = prevProps.match.params;

    if (prevSlug != slug) {
      const requestData = {
        q: slug,
        page: 1,
      }
      this.props.Search(requestData).then((data) => {
        this.setState({
          content: data,
          slug: slug
        })
      });
    }
  }

  contentLoad = () => {
    const { content, slug } = this.state;
    const current_page = content.current_page;
    const to = content.to;
    const total = content.total;
    const requestData = {
      page: current_page + 1,
      q: slug,
    }
    const req = this.props.Search(requestData).then((data) => {


      const getcontent = data;
      const newdata = data.data;
      delete data.data;

      var newstate = {
        ...this.state,
        content: {
          ...data,
          data: [
            ...this.state.content.data,
            ...newdata
          ]
        }
      }
      this.setState({
        ...newstate
      })

    });
  }


  setPathLayout = (parms) => {
    this.props.setPathLayout(parms);
  }
  getSetting = async () => {
    let data = await this.props.getSetting();
  }

  getContentData = (menu_id) => {

    const requestData = {
      menu_id: menu_id,
    }
    this.props.sectionandContent(requestData);
  }

  render() {

    var { slug, content } = this.state;

    console.log('search_data=', content);

    return (
      <Fragment>

        {
          Object.keys(content).length ?
            <section className="search-page mt-5">

              <div className="container">

                <div className="search-info">
                  <h1>Search results for <span>“{slug}”</span></h1>

                  <h3 className="total-result">Total Search Result: {content.total}</h3>
                </div>
                <Fragment>
                  <div className="search-content">


                    {
                      content.data.map((rows, keys) => {
                        const catid = rows.categories.length ? rows.categories[0]['id'] : '0';
                        return (
                          <Fragment key={keys}>
                            <div className="search-single" >

                              <h3><Link to={{ pathname: `/news/${catid}/${rows.id}/details` }} replace > {rows.title} </Link></h3>

                              <p>
                                {rows.short_description}
                              </p>

                            </div>
                          </Fragment>
                        )

                      })
                    }

                  </div>
                </Fragment>

                {Object.keys(content).length ? <Fragment>
                  {content.to < content.total && <Fragment>
                    <div className="text-center">
                    <button className="btn btn-primary " onClick={this.contentLoad}>Load More</button>
                    </div>
                  </Fragment>}
                </Fragment> : ''}
              </div>
            </section>
            :
            ''
        }



      </Fragment>

    )
  }
}

const mapStateToProps = state => ({
  utils: state.utils,
  header: state.header,
  contents: state.contents,
  footer: state.footer,
  layout_id: state.utils.layout_id,
  routemenu: state.utils.routemenu,
  setting: state.utils.setting,

})

const mapDispatchToProps = dispatch => ({
  Search: (requestData) => dispatch(Search(requestData)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchPage));